import { render } from "./AlertContactsView.vue?vue&type=template&id=0ecd38c8"
import script from "./AlertContactsView.vue?vue&type=script&lang=js"
export * from "./AlertContactsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__